import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Tag, Table } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import SeeAll from "../../../assets/icons/seeAll.svg"
import complaintActions from '../../../redux/complaints/actions'
const { getComplaintsData } = complaintActions

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a?.key - b?.key,
    width: 100, // Fixed width
  },
  {
    title: "DATE",
    dataIndex: "date",
    sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
    width: 100, // Fixed width
       render: (text, record) => (
          <>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("hh:mm:ss A")}
            </p>
          </>
        ),
  },
  {
    title: "COMPLAINT ID",
    dataIndex: "complaint_id",
    sorter: (a, b) => a.complainId?.localeCompare(b.complainId),
    width: 100, // Fixed width
  },
  {
    title: "COMPLAINT TYPE",
    dataIndex: "complaint_type",
    sorter: (a, b) => a.complaint_type?.localeCompare(b?.complaint_id),
    width: 100, // Fixed width
  },
  {
    title: "OPEN COMPLAINT",
    dataIndex: "open_complaint",
    width: 100, // Fixed width
  },
  {
    title: "ASSIGNED",
    dataIndex: "assigned",
    width: 100, // Fixed width
  },

  {
    title: "STATUS",
    dataIndex: "status",
    width: 100, // Fixed width
  },

  {
    title: "DISPOSITION",
    dataIndex: "disposition",
    width: 100, // Fixed width
  },
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    width: 100, // Fixed width
  },
];

function ComplaintsTable() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [tableParams, setTableParams] = useState({
        current: 1,
        pageSize: 10,
    });
    const { complaintsData, loading } = useSelector((state) => state.complaintReducer)
    const profileData = useSelector(state => state.authReducer.profileData);


    useEffect(() => {
        const agentId = profileData?.orgId
        if(agentId)
            dispatch(getComplaintsData(0 , 10, "", "", "", agentId));
    }, [dispatch, profileData?.orgId])

    const navigateToTransactionPage = () => {
        navigate('/complaints');
    };

    var data =
      complaintsData.complaints &&
      complaintsData.complaints.length > 0 &&
      complaintsData.complaints.slice(0, 5).map((items, index) => {
        return {
          key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
          complaint_id: items?.response?.txnStatusComplainResp[0]
            ?.complaintId || <Tag>{""}</Tag>,

          complaint_type: items?.request?.complaintType,
          open_complaint: (
            <Tag
              color={
                items?.response?.txnStatusComplainResp[0]?.openComplaint === "N"
                  ? "red"
                  : "green"
              }
            >
              {items?.response?.txnStatusComplainResp[0]?.openComplaint || ""}
            </Tag>
          ),
          assigned: items?.response?.txnStatusComplainResp[0]?.assigned || (
            <Tag>{""}</Tag>
          ),

            description: (
                   <Tag
                     style={{
                       border: "none",
                       backgroundColor: "transparent",
                     }}
                     className="draft"
                   >
                     {" "}
                     {items?.request.description ? (
                       <textarea
                         rows={2}
                         readOnly
                         style={{
                           outline: "none",
                           border: "none",
         
                           resize: "verticle",
                           overflow: "hidden", // Hide scrollbars
                           whiteSpace: "pre-wrap",
         
                           fontSize: "14px",
                           color: "#333",
                         }}
                         value={items?.request.description || ""} // Fallback for undefined values
                       />
                     ) : (
                       <Tag>{""}</Tag>
                     )}
                   </Tag>
                 ),
                   
                 disposition: (
                     <Tag
                       style={{
                         border: "none",
                         backgroundColor:"transparent"
                       }}
                       className="draft"
                     >
                       {" "}
                       {items?.request.disposition? <textarea
                         rows={2}
                         readOnly
                         style={{
                           outline: "none",
                           border: "none",
                          
                           resize: "verticle",
                           overflow: "hidden", // Hide scrollbars
                           whiteSpace: "pre-wrap",
           
                           fontSize: "14px",
                           color: "#333",
                         }}
                         value={items?.request.disposition || ""} // Fallback for undefined values
                       /> : <Tag>{""}</Tag>}
                       
                     </Tag>
                   ),
          
          date: (
            <>
              <p className="m-0 p-0">
                {moment(items?.createdAt).format("DD MMMM YYYY")}
              </p>
              <p className="m-0 p-0">
                {moment(items?.createdAt).format("hh:mm:ss A")}
              </p>
            </>
          ),

          // items?.cuResponse?.toLowerCase() === "successful"

          createdAt: items.createdAt || "",
          status: (
            <Tag
             
               style={{
                border: "none",
                 backgroundColor:"transparent"
             
            }}
              className="draft"
            >
              {items?.response?.txnStatusComplainResp[0]?.responseReason !==
              "SUCCESS" ? (
                <textarea
                  rows={2}
                  readOnly
                  style={{
                    outline: "none",
                    border: "none",
                    resize: "verticle",
                    overflow: "hidden", // Hide scrollbars
                    whiteSpace: "pre-wrap",

                    fontSize: "14px",
                    color: "#333",
                  }}
                  value={
                    items?.response?.txnStatusComplainResp[0]?.responseReason ||
                    "No Reason Provided"
                  }
                />
              ) : (
                items?.response?.txnStatusComplainResp[0]?.responseReason
              )}
            </Tag>
          ),
        };
      });


    return (
        <div>
            <div className="headingTag">
                <h1>Complaints</h1>
                <div onClick={navigateToTransactionPage} style={{ cursor: 'pointer' }}>See All  <img src={SeeAll} alt='seeAll'></img></div>
            </div>
            <div className="tableComplaint">
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={false}
                    scroll={{ x: 600 }}

                />
            </div>
        </div>
    )
}

export default ComplaintsTable;
